import { Typography } from "@material-ui/core";
import clsx from "clsx";
import { QuickWinApi } from "../../learning-path/learningPath.service";
import { Status, getReadableStatus } from "../../models/gameplan";
import {
  CheckedCircleIcon,
  ExclamationIcon,
  QuickwinTrophyIcon,
} from "../../shared/icons/gamePlan";
import { quickwinCardStyles } from "./quickwin-card.styles";

interface QuickwinCardProps {
  quickwin: QuickWinApi;
  className?: string;
}

export const QuickwinCard = ({ quickwin, className }: QuickwinCardProps) => {
  const { name, status } = quickwin;
  const classes = quickwinCardStyles();
  const isCompleted = status === Status.COMPLETED;

  return (
    <div className={clsx(classes.card, className)}>
      <div className={classes.header}>
        <div>
          <QuickwinTrophyIcon />
        </div>
        <div>
          <Typography variant="h6" className={classes.title}>
            {name}
          </Typography>
        </div>
      </div>
      <div>
        <span
          className={clsx(classes.statusDetails, {
            [classes.completed]: isCompleted,
            [classes.notStarted]: !isCompleted,
          })}
        >
          {isCompleted ? <CheckedCircleIcon /> : <ExclamationIcon />}
          {getReadableStatus(status)}
        </span>
      </div>
    </div>
  );
};
